﻿import React from "react";
import { Box, CircularProgress } from "@mui/material";

function DotLegalFullScreenSpinner() {
    return (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <CircularProgress />
        </Box>
    );
}

export default DotLegalFullScreenSpinner;
